import { useTranslations } from "@jugl-web/utils";
import { InvoiceType } from "@jugl-web/rest-api";

import { ReactComponent as ConvertToProformaIcon } from "../assets/convert-proforma.svg";
import { ReactComponent as ConvertToInvoiceIcon } from "../assets/convert-invoice.svg";
import { ReactComponent as ConvertToPurchaseIcon } from "../assets/convert-purchase.svg";

export const useChangeInvoiceTypeOptions = ({
  type,
}: {
  type: InvoiceType | undefined;
}) => {
  const { t } = useTranslations();
  if (!type || type === "invoice") return [];

  const options = [
    {
      id: "convert-to-proforma",
      label: t({
        defaultMessage: "Convert to Proforma",
        id: "invoices.convert-to-proforma",
      }),
      icon: <ConvertToProformaIcon />,
      isHidden: type === "proforma",
    },
    {
      id: "convert-to-invoice",
      label: t({
        defaultMessage: "Convert to Invoice",
        id: "invoices.convert-to-invoice",
      }),
      icon: <ConvertToInvoiceIcon />,
    },
    {
      id: "convert-to-purchase-order",
      label: t({
        defaultMessage: "Convert to Purchase Order",
        id: "invoices.convert-to-purchase-order",
      }),
      icon: <ConvertToPurchaseIcon />,
      isHidden: type === "purchase_order",
    },
  ];

  return options;
};
